export default __webpack_public_path__ + "static/locked-89d4b8d6bc91015d68074e5597fd8df2.png";